import { createContext, PropsWithChildren, useEffect, useState } from "react";
import API from "@/api";
import { LoginResponse } from "@/api/authentication";

const TOKEN_KEY = "token";

export interface IAuthContext {
  token?: string;
  login: (username: string, password: string) => Promise<LoginResponse>;
  logout: () => void;
  isAuthenticated: boolean;
}

export const AuthContext = createContext<IAuthContext | null>(null);

export function AuthProvider({ children }: PropsWithChildren) {
  const [token, setToken] = useState<string>();
  const isAuthenticated = !!token;

  useEffect(() => {
    // Hydrate auth state from local storage
    const storedToken = localStorage.getItem(TOKEN_KEY);
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const login = (username: string, password: string): Promise<LoginResponse> => {
    return API.login(username, password)
      .then((response) => {
        setToken(response.token);
        localStorage.setItem(TOKEN_KEY, response.token);
        return response;
      });
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem("cache_date");
    localStorage.removeItem("rack_photo_guide_hidden");
    setToken(undefined);
  };

  const contextValue = {
    token,
    isAuthenticated,
    login,
    logout
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
}
